import { connect } from 'react-redux';
import Routes from 'containers/Routes';
import LoadingIndicator from 'components/Common/LoadingIndicator';
import SessionTimer from 'components/Common/SessionTimer';
import CacheBuster from 'components/CacheBuster/index';

const App = ({ isCheckingMe, isStoredTokenVerified, ...rest }: any) => {
  if (!isStoredTokenVerified && isCheckingMe) {
    return (
      <div className="app">
        <LoadingIndicator isLoading={true} fullScreen />
      </div>
    );
  }

  return (
    <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }: any) => {
        if (loading) {
          return <div>...loading</div>;
        }

        if (!loading && !isLatestVersion) {
          refreshCacheAndReload();
        }

        return (
          <div className="app">
            <Routes {...rest} />
            <SessionTimer />
          </div>
        );
      }}
    </CacheBuster>
  );
};

const mapStateToProps = (store: any) => ({
  isCheckingMe: store.rootReducer.auth.isCheckingMe,
  isStoredTokenVerified: store.rootReducer.auth.isStoredTokenVerified,
});

export default connect(mapStateToProps)(App);
